import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiAccordion from '@material-ui/core/Accordion';
import { combineClasses, styled, useThemeProps, } from '../../foundation';
import { AccordionStyle } from './styles';
import { RcAccordionClasses } from './utils';
var _RcAccordion = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcAccordion' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcAccordionClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiAccordion, __assign({ square: true }, rest, { ref: ref, classes: classes }), children));
});
var RcAccordion = styled(_RcAccordion)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), AccordionStyle);
RcAccordion.defaultProps = {};
RcAccordion.displayName = 'RcAccordion';
export { RcAccordion };
var templateObject_1;
